import { h, Component } from 'preact';
import { Router, route } from 'preact-router';

import Header from './header';
import Loading from './loading';

// Code-splitting is automated for routes
import Home from '../routes/home';
import Login from '../routes/login';
import Logout from '../routes/logout';
import OnboardingYoutubeConnect from '../routes/youtubeConnect';
import Redirect from '../routes/redirect';
import YoutubeList from '../routes/youtubeList';
import OnboardingCooking from '../routes/onboardingCooking';
import OnboardingPayment from '../routes/onboardingPayment';

import MagicLinkReceive from '../routes/magicLink';
import PassswordReset from '../routes/passwordReset';
import PassswordResetConfirm from '../routes/passwordResetConfirm';

import Search from '../routes/search/search';
import SearchEngineList from '../routes/search/SearchEngineList';

import Payment from '../routes/payment';
import AddPaymentMethod from '../routes/addPaymentCard';

import TeamManagement from '../routes/teams/teamManagement';
import TeamMembers from '../routes/teams/members';
import TeamJoin from '../routes/teams/teamJoin';
import TeamYoutubeConneect from '../routes/teams/youtubeConnect';

import Terms from '../routes/terms';

import Cookies from 'js-cookie';

import { isLocalStorageEnabled } from './utils/utils';
import { apiGetRequest } from './utils/api';

import LogRocket from 'logrocket';
import '@fortawesome/fontawesome-free/css/all.min.css';
import InviteMembers from '../routes/teams/inviteMembers';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import { mixpanel } from './utils/utils';
import TeamAPIKeys from '../routes/teams/teamAPIKeys';
import DemoSearchEngineList from '../routes/demo/demoList';
import DemoSearch from '../routes/demo/demoSearchEngine';
const checkForUpdate = require("spa-check-for-update");

LogRocket.init('curatr/curatr-app');

mixpanel.init("99a071944551fec4f0d93acb936beb5c");


export default class App extends Component {	
	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */

	constructor(props){
		super(props);
		this.state = {
			authToken: "",
			authenticated: false,
            loading: true,
            userProfile: {},
            appLoading: false,
            team: {
                name: ""
            }
		}
	}

	handleRoute = e => {
        this.currentUrl = e.url;
        if (e.url.includes("redirect")) {
            return true
        }
		if (this.state.authenticated) {
            if (this.state.userProfile.onboarding_complete) {
                if (!this.state.userProfile.membership_active) {
                    route("/payment", true);
                    return ;
                } else {
                    let non_allowed = [
                        '/register',
                        '/login',
                        '/onboarding',
                        '/payment',
                        '/team/join'
                    ];
                    if (non_allowed.find((item) => e.url.includes(item)) || e.url == '/') {
                        route("/search/list", true);
                    };
                }
            } else {
                switch (this.state.userProfile.onboarding_stage) {
                    case 0:
                        route("/onboarding/youtube/connect", true);
                        break;
                    case 1:
                        route("/onboarding/payment", true);
                        break;
                    case 2:
                        route("/onboarding/wait", true);
                        break;
                }
            }			
		} else {
            let non_allowed = [
                '/search',
                '/team/managment/',
                '/onboarding/'
            ];
            if (non_allowed.find((item) => e.url.includes(item))) {
                route("/", true);
            }
		}
    };
    
    getTeamBasicInfo(url_identifier) {
        apiGetRequest("teams/get-info?url_identifier=" + url_identifier).then((data) => {
            if (data.team_name) {
                this.setState({team: data, loading: false});
            } else {
                console.log(data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }

	changeAuthenticationStatus(value) {
		this.setState({authenticated: value});
	}

	changeAuthToken(value) {
		this.setState({auth_token: value});
		if (isLocalStorageEnabled()) {
			console.log("Set Local Storage Works!");
			localStorage.setItem("auth_token", value);
		} else {
			console.log("Setting using Cookies!");
			Cookies.set('auth_token', value);
		}	
    }
    
    changeAppLoading(value) {
        this.setState({appLoading: value});
    }

    getUserProfile(authToken) {
        return new Promise((resolve, reject) => {
            apiGetRequest("rest-auth/user/", "", true, authToken).then((data) => {
                console.log(data);
				if (data.pk) {
                    var loading = false;
                    this.changeAuthenticationStatus(true);
                    
                    LogRocket.identify(data.pk, {
                        name: data.first_name,
                        email: data.username,
                    });

                    mixpanel.identify(data.pk);
                    mixpanel.people.set(data);

                    if (data.url_identifier) {
                        loading = true;
                    }

                    this.setState({loading: loading, authToken: authToken, userProfile: data}, () => {
                        if (data.url_identifier) {
                            this.getTeamBasicInfo(data.url_identifier);
                            resolve();
                        } 
                    });
				}
			}).catch((error) => {
                console.log(error);
				this.changeAuthToken("");
                this.setState({loading: false});
                reject();
			})
        })
    }

	componentDidMount() {
        const originalFetch = window.fetch;
        window.fetch = function (url) {
            if (!url.includes("/index.html") && !url.includes("/login") && !url.includes("/magic-link-send")) {
                checkForUpdate(
                    () => {
                        location.reload();
                    },
                    () => {
                        console.error("Check for Update Error")
                    }
                );
            }
            return originalFetch.apply(window, arguments);
        };
		var authToken = null;

		if (isLocalStorageEnabled()) {
			console.log("Local Storage Works!");
			authToken = localStorage.getItem("auth_token");
		} else {
			authToken = Cookies.get('auth_token');
        }

		if (authToken) {
			this.getUserProfile(authToken);
		} else {
			this.setState({loading: false});
		}
	}

	render() {
		if (this.state.loading) {
            <Loading />
		} else {
			return (
				<div id="app"> 
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                    />
                    
                    {this.state.appLoading &&
                        <Loading />
                    }

					<Router onChange={this.handleRoute}>
                        <Terms path="/terms" />

						<Home path="/" 
                            changeAuthenticationStatus={(value) => this.changeAuthenticationStatus(value)}
                            changeAuthToken={(value) => this.changeAuthToken(value)}
                            setUserProfile={(userProfile) => this.setState({userProfile: userProfile})}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            mixpanel={mixpanel}
                        />
						<Login path="/login" 
							changeAuthenticationStatus={(value) => this.changeAuthenticationStatus(value)}
                            changeAuthToken={(value) => this.changeAuthToken(value)}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            mixpanel={mixpanel}
                            getUserProfile={(token) => this.getUserProfile(token)}
						/>

                        <TeamJoin path="/team/join/:token" 
							changeAuthenticationStatus={(value) => this.changeAuthenticationStatus(value)}
                            changeAuthToken={(value) => this.changeAuthToken(value)}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            team={this.state.team}
                            mixpanel={mixpanel}
                            getUserProfile={(token) => this.getUserProfile(token)}
						/>

                        <TeamManagement path="/team/management" 
                            authToken={this.state.authToken}
                            changeAuthenticationStatus={(value) => this.changeAuthenticationStatus(value)}
                            changeAuthToken={(value) => this.changeAuthToken(value)}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            team={this.state.team}
                            mixpanel={mixpanel}
                        />

                        <TeamMembers path="/team/management/members" 
                            authToken={this.state.authToken}
                            changeAuthenticationStatus={(value) => this.changeAuthenticationStatus(value)}
                            changeAuthToken={(value) => this.changeAuthToken(value)}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            team={this.state.team}
                            mixpanel={mixpanel}
                        />

                        <TeamAPIKeys path="/team/management/api" 
                            authToken={this.state.authToken}
                            changeAuthenticationStatus={(value) => this.changeAuthenticationStatus(value)}
                            changeAuthToken={(value) => this.changeAuthToken(value)}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            team={this.state.team}
                            mixpanel={mixpanel}
                        />

                        <TeamYoutubeConneect path="/team/youtube/connect" 
                            authToken={this.state.authToken}
                            userProfile={this.state.userProfile}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            mixpanel={mixpanel}
						/>

                        <InviteMembers path="/team/management/members/invite" 
                            authToken={this.state.authToken}
                            changeAuthenticationStatus={(value) => this.changeAuthenticationStatus(value)}
                            changeAuthToken={(value) => this.changeAuthToken(value)}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            team={this.state.team}
                            mixpanel={mixpanel}
                        />

						<YoutubeList path="/youtube/list"
                            authToken={this.state.authToken}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            mixpanel={mixpanel}
						/>
	
						<OnboardingYoutubeConnect path="/onboarding/youtube/connect" 
                            authToken={this.state.authToken}
                            userProfile={this.state.userProfile}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            mixpanel={mixpanel}
						/>

                        <OnboardingCooking path="/onboarding/wait"
                            authToken={this.state.authToken}
                            userProfile={this.state.userProfile}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            mixpanel={mixpanel}
                        />

                        <OnboardingPayment path="/onboarding/payment"
                            authToken={this.state.authToken}
                            userProfile={this.state.userProfile}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            mixpanel={mixpanel}
                        />

						<Redirect path="/youtube/redirect" 
                            authToken={this.state.authToken}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            mixpanel={mixpanel}
						/>
                        
                        <SearchEngineList path="/search/list" 
                            authToken={this.state.authToken}
                            userProfile={this.state.userProfile}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            team={this.state.team}
                            mixpanel={mixpanel}
                        />

                        <Search path="/search/engine/:id" 
                            authToken={this.state.authToken}
                            userProfile={this.state.userProfile}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            team={this.state.team}
                            mixpanel={mixpanel}
                        />

                        <Payment path="/payment"
                            authToken={this.state.authToken}
                            userProfile={this.state.userProfile}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            team={this.state.team}
                            mixpanel={mixpanel}
                        />

                        <AddPaymentMethod path="/payment/add-method"
                            authToken={this.state.authToken}
                            userProfile={this.state.userProfile}
                            changeAppLoading={(value) => this.changeAppLoading(value)}
                            team={this.state.team}
                            mixpanel={mixpanel}
                        />

                        <MagicLinkReceive path="/login/magic-link/receive/:uid/:token/"
                            authenticated={this.state.authenticated}
                            auth_token={this.state.authToken}
                            changeAuthenticationStatus={value => this.changeAuthenticationStatus(value)}
                            changeAuthToken={value => this.changeAuthToken(value)}
                            changeAppLoading={value => this.changeAppLoading(value)}
                            mixpanel={mixpanel}
                        />
                        <PassswordReset path="/password-reset"
                            authenticated={this.state.authenticated}
                            auth_token={this.state.authToken}
                            changeAuthenticationStatus={value => this.changeAuthenticationStatus(value)}
                            changeAuthToken={value => this.changeAuthToken(value)}
                            changeAppLoading={value => this.changeAppLoading(value)}
                            mixpanel={mixpanel}
                        />
                        <PassswordResetConfirm path="/password-reset-confirm/:uid/:token"
                            authenticated={this.state.authenticated}
                            auth_token={this.state.authToken}
                            changeAuthenticationStatus={value => this.changeAuthenticationStatus(value)}
                            changeAuthToken={value => this.changeAuthToken(value)}
                            changeAppLoading={value => this.changeAppLoading(value)}
                            mixpanel={mixpanel}
                        />

                        <Logout path="/logout" 
                            changeAuthenticationStatus={value => this.changeAuthenticationStatus(value)}
                            changeAuthToken={value => this.changeAuthToken(value)}
                            changeAppLoading={value => this.changeAppLoading(value)}
                        />

                        <DemoSearchEngineList path="/demo/list"
                            mixpanel={mixpanel}
                        />

                        <DemoSearch path="/demo/engine/:id/"
                            mixpanel={mixpanel}
                        />
					</Router>
				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./components/app.js